import { z } from 'zod';

export const BPFSchema = z.object({
  businessProcessFlowId: z.string().uuid(),
  currentStage: z.string().uuid(),
});

export const UpdateBPFVariablesSchema = z.object({
  VOId: z.string().uuid(),
  fieldsObj: z.object({
    businessProcessFlows: z.object({
      flows: z.array(BPFSchema),
    }),
  }),
});

export const DepartmentSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export const NoteAttributeSchema = z.object({
  field: z.literal('notes'),
  name: z.string(),
  value: z.string().optional(),
});

export const ChecklistItemSchema = z.object({
  name: z.string(),
  value: z.boolean().optional(),
});

export const ChecklistAttributeSchema = z.object({
  field: z.literal('checklist'),
  value: z.array(ChecklistItemSchema),
});

export const AllAttributesTypesSchema = z.discriminatedUnion('field', [NoteAttributeSchema, ChecklistAttributeSchema]);

export const StageSchema = z.object({
  name: z.string(),
  ordinal: z.number(),
  completionRules: z.string(),
  stageFields: z.array(AllAttributesTypesSchema),
  businessProcessFlowId: z.string().uuid(),
  businessProcessFlowStageId: z.string().uuid(),
});

export const CreateStageSchema = z.object({
  name: z.string(),
  ordinal: z.number(),
  completionRules: z.any(),
  stageFields: z.array(AllAttributesTypesSchema),
});

export const TemplateSchema = z.object({
  name: z.string(),
  stages: z.array(StageSchema),
  accountId: z.string().uuid(),
  department: DepartmentSchema,
  businessProcessFlowId: z.string().uuid(),
});

export const CreateBPFTemplateSchema = z.object({
  accountId: z.string().uuid(),
  departmentId: z.string().uuid(),
  name: z.string().min(1),
  stages: z.array(CreateStageSchema),
});

export const UpdateBPFTemplateSchema = z
  .object({
    businessProcessFlowId: z.string().uuid(),
  })
  .and(CreateBPFTemplateSchema);

export const UpdateTemplateStageFieldsSchema = z.object({
  businessProcessFlowStageId: z.string().uuid(),
  stageFields: z.array(AllAttributesTypesSchema),
});

export const DepartmentsVariablesSchema = z.object({
  input: z.object({
    accountId: z.string().uuid(),
  }),
});

export const TemplatesVariablesSchema = z.object({
  input: z.object({
    accountId: z.string().uuid(),
  }),
});
